import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LoaderService } from "@app/core/services/loader/loader.service";
import { NotificationService } from "@app/core/services/notification/notification.service";
import { APIResponse } from "@app/shared/services/core/ICore.interface";
import { ErrorhandlerService } from "@app/shared/services/errorhandler/errorhandler.service";
import { ProductService } from "@app/shared/services/product/product.service";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.css"]
})
export class UploadFileComponent implements OnInit {
  fileUploaded = false;
  file: File;
  fileName = "";
  errorMessage: string;
  @ViewChild("myInput") fileVariable!: any;

  constructor(
    private dialogRef: MatDialogRef<UploadFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notification: NotificationService,
    private productService: ProductService,
    private loader: LoaderService,
    private errorhandlerService: ErrorhandlerService
  ) {}

  ngOnInit() {}

  fileChangeEvent(event: any): void {
    this.errorMessage = "";
    this.fileName = "";
    this.fileUploaded = false;
    if (event.target.files.length > 0) {
      const type = event.target.files[0].type;
      const size = event.target.files[0].size;
      if (
        type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.fileVariable.nativeElement.value = "";
        this.notification.error("Invalid type file", "Type");
        return;
      }
      if (Math.round(size / 1024) >= 10240) {
        this.fileVariable.nativeElement.value = "";
        this.notification.error("Size must be less than 5 Mb", "Size");
        return;
      } else {
        this.fileName = event.target.files[0].name;
        this.file = event.target.files[0];
        this.fileUploaded = true;
      }
    }
  }

  fn_UploadFile() {
    if (this.file) {
      this.notification.info("Sheet is being uploaded, you will be notified via email once the process gets completed, it takes around 10-15 mins based on the file data!", "Info");
      this.dialogRef.close();
      this.errorMessage = "";
      const formData = new FormData();
      formData.append("file", this.file, this.file.name);
      this.productService.uploadProductFeatures(formData).subscribe(
        (res: APIResponse<any>) => {
          this.loader.hide();
          if (res.StatusCode === 200) {
            //this.notification.success("File is successfully uploaded!", "Success");
          } else {
            if (res.Data.ResponseData)
              this.errorMessage = res.Data.ResponseData;
            //else this.notification.error(res.Message, "Error");
          }
        },
        (err: any) => {
          //this.errorhandlerService.handleError(err);
        }
      );
    }
  }
}
